import { isLoginCheck } from '@Components/Common/CommonMethods';
import KitOrderListing from '@PagesComponent/KitFrom/KitOrderListing';
import KitSuccessPage from '@PagesComponent/KitFrom/KitSuccessPage';
import MyselfForm from '@PagesComponent/KitFrom/MyselfForm';
import OtherForm from '@PagesComponent/KitFrom/OtherForm';
import KitPageValues, { ChoodeConsentDialogStyle } from '@PagesComponent/KitFrom/KitStyle.style';
import KitCheckout from '@PagesComponent/KitFrom/KitCheckout';
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import useKitFormHook from '../../Components/KitFrom/KitFrom.hook';
import KitThankyouPage from '@PagesComponent/KitFrom/KitThankyouPage';
import DialogComponent from '@Components/Common/DialogComponent';

const ChooseOptionForConsent = ({ section, open, close, setChooseOption, profile, isLoginCheck, removeStorages }) => {

    function chooseOption(value) {
        if (section === "checkout") {
            if (value === "other") {
                removeStorages();
            }
        }
        setChooseOption(value);
        close(false);
    }

    return (
        <DialogComponent opend={open} handleClose={close} title="Choose your consent" classFor="consent_form_dialog">
            <ChoodeConsentDialogStyle className='main_consent_options'>
                <div className='text_value'>
                    <p>You are currently logged in as {profile?.first_name + ' ' + profile?.last_name} do you want this DNA test kit to be registered to you?</p>
                </div>
                <div className='first_button'>
                    <button onClick={() => chooseOption('myself')}>Yes, continue as {profile?.first_name + ' ' + profile?.last_name}</button>
                </div>
                <div className='second_button'>
                    <button onClick={() => chooseOption('other')}>No, connect this kit to a new person</button>
                </div>
            </ChoodeConsentDialogStyle>
        </DialogComponent>
    );
}

const KitFromPage = (props) => {
    const router = useRouter();
    //insert values in same postion as you return from the hook
    const [
        storeShippingData,
        barCodeValue, setBarCodeValue, handleSubmit,
        mySelfFormSubmit, imageError, success,
        otherFormSubmit, otherSuccessMsg, otherImageError, errorOtherKitMsg,
        isBarcodeAutoship,
        quantity, frequencyDate, onQtyfuntion, setAutoshipFunction, checkedProduct,
        setCheckedProduct, frequentlyProduct, streetData, setStreetData,
        freeKitProduct, duplicateFreeKitProduct, savedCard, errorKitMsg,
        handleCheckoutSubmit, errorCheck,
        orderedData, publicOrderId,
        shippingAmount, checkoutOrderId, goToConsent,
        discountValues, setDiscountValue, removedCoupon, appliedCouponFunc,
        openConsentOption, setOpenConsentOption, chooseOption, setChooseOption, storeBarcode,
        alreadyConcentMsg, _handleCheckUserConsent, isBundleProduct, openKitPopup, setOpenKitPopup, alreadyExistUser,
        setDuplicateFreeKitProduct, setFreeKitProduct,
        setAmountCalculations, amountCalculations,
    ] = useKitFormHook(props);

    const routeData = router?.asPath === "/us/kit_form/?r=success";

    const [barCodeValueData, setBarCodeValueData] = useState();
    const [consentFormValue, setConsentFormValue] = useState();
    const [consentFormCheck, setConsentFormCheck] = useState();

    useEffect(() => {
        const BARCODE_VALUE = localStorage.getItem("barcode");
        setBarCodeValueData(BARCODE_VALUE);
        const CONSENT_FORM = localStorage.getItem("consentForm");
        setConsentFormValue(CONSENT_FORM);
        const CONSENT_FORM_CHECK = localStorage.getItem("consentFormCheckout");
        setConsentFormCheck(CONSENT_FORM_CHECK);

    }, [])

    return (
        <KitPageValues>
            <div className='order-kit'>
                <div className={`${router.asPath === '/us/kit_form/?checkout' ? "order-wrapper checkout" : 'order-wrapper'}`}>
                    {(!barCodeValue && !routeData && freeKitProduct?.length === 0 && !consentFormValue && !consentFormCheck) &&
                        <KitOrderListing kitListingState={{ handleSubmit }} openKitPopup={openKitPopup} setOpenKitPopup={setOpenKitPopup} />
                    }
                    {(barCodeValue || barCodeValueData) && routeData
                        ?
                        <>
                            <KitSuccessPage kitSuccessProps={{
                                frequencyDate, onQtyfuntion, frequentlyProduct, quantity, setAutoshipFunction, checkedProduct, setCheckedProduct,
                            }} {...props} />
                            {orderedData?.id &&
                                <KitThankyouPage thankyouProps={{
                                    orderedData, publicOrderId, shippingAmount, checkoutOrderId, goToConsent
                                }} />
                            }
                        </>

                        :
                        <>
                            {freeKitProduct?.length > 0 || consentFormCheck
                                ?
                                <>
                                    {(checkoutOrderId === null || consentFormCheck) ?
                                        <>
                                            <KitCheckout freeKitProps={{
                                                freeKitProduct, frequentlyProduct, streetData, setStreetData, setBarCodeValue, savedCard, handleCheckoutSubmit, errorCheck,
                                                discountValues, setDiscountValue, removedCoupon, appliedCouponFunc, amountCalculations,
                                                profileData: props?.profileData?.user_data, setDuplicateFreeKitProduct, setFreeKitProduct, ...props
                                            }} />

                                        </>

                                        :
                                        <MyselfForm mySelfState={{
                                            alreadyConcentMsg,
                                            _handleCheckUserConsent,
                                            storeShippingData,
                                            profileData: props?.profileData?.user_data,
                                            imageError, success, isBarcodeAutoship, mySelfFormSubmit, setBarCodeValue, errorKitMsg, isBundleProduct, alreadyExistUser,
                                        }} />
                                    }
                                </>
                                :
                                <>
                                    {(isLoginCheck() && (barCodeValue || storeBarcode)) &&
                                        <>
                                            <ChooseOptionForConsent
                                                section={duplicateFreeKitProduct?.length > 0 ? "checkout" : "kit_form"}
                                                open={openConsentOption}
                                                profile={props?.profileData?.user_data}
                                                close={setOpenConsentOption}
                                                setChooseOption={setChooseOption}
                                                removeStorages={props?.removeStorages}
                                                isLoginCheck={isLoginCheck}
                                            />
                                            {chooseOption === "myself" &&
                                                <MyselfForm mySelfState={{
                                                    alreadyConcentMsg,
                                                    _handleCheckUserConsent,
                                                    storeShippingData,
                                                    profileData: props?.profileData?.user_data,
                                                    imageError, success, isBarcodeAutoship, mySelfFormSubmit, setBarCodeValue, errorKitMsg, isBundleProduct, alreadyExistUser,
                                                }} />
                                            }
                                            {chooseOption === "other" &&
                                                <OtherForm otherState={{
                                                    storeShippingData, alreadyConcentMsg, _handleCheckUserConsent, otherFormSubmit, isBundleProduct, isBarcodeAutoship, otherSuccessMsg, setBarCodeValue, errorOtherKitMsg, otherImageError, alreadyExistUser, ...props
                                                }} />
                                            }
                                        </>
                                    }
                                    {(!(isLoginCheck()) && barCodeValue) &&
                                        <OtherForm otherState={{
                                            storeShippingData, alreadyConcentMsg, _handleCheckUserConsent, otherFormSubmit, isBundleProduct, isBarcodeAutoship, otherSuccessMsg, setBarCodeValue, otherImageError, errorOtherKitMsg, alreadyExistUser, ...props
                                        }} />
                                    }

                                    {(router?.asPath === "/us/kit_form/?checkout" && consentFormValue) &&
                                        <MyselfForm mySelfState={{
                                            alreadyConcentMsg,
                                            _handleCheckUserConsent,
                                            storeShippingData,
                                            profileData: props?.profileData?.user_data,
                                            imageError, success, isBarcodeAutoship, mySelfFormSubmit, setBarCodeValue, errorKitMsg, isBundleProduct, alreadyExistUser,
                                        }} />
                                    }


                                </>
                            }
                        </>
                    }
                </div>
            </div>
        </KitPageValues>

    )
}

export default KitFromPage;